import React from "react";
import {useFormik} from "formik";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button";
import {createFilterOptions} from "@mui/material";
import GeoService from "../../services/geo";
import Box from "@mui/material/Box";
import CountryFlag from "../CountryFlag";
import Autocomplete from "@mui/material/Autocomplete";


const CountryAttributeForm = (props) => {
    const {
        attribute,
        label,
        value,
        defaultValue = "",
        validationSchema,
        onClose,
        onSubmit,
        isLoading,
        dialogTitle,
    } = props

    const formik = useFormik({
        initialValues: {[attribute]: value == null ? defaultValue : value },
        validationSchema: validationSchema,
        validateOnMount: true,
        onSubmit: onSubmit,
    });

    const filterOptions = createFilterOptions({
        matchFrom: 'start'
    });

    return <Dialog onClose={onClose} open={true} fullWidth>
        <DialogTitle>
            {dialogTitle ? dialogTitle : `Aggiorna ${label.toLowerCase()}`}
        </DialogTitle>
        <DialogContent>
            <Autocomplete
                options={GeoService.COUNTRIES}
                filterOptions={filterOptions}
                autoHighlight
                getOptionLabel={(option) => option.label}
                value={GeoService.COUNTRIES.find(c => c.code === formik.values.nationality) || null}
                onChange={(event, value) => {
                    formik.setFieldValue("nationality", value ? value.code : null)
                }}
                renderOption={(props, option) => (
                    <Box component="li"
                         sx={{fontSize: 15, '& > img': {mr: 1}}}
                         {...props}>
                        <CountryFlag code={option.code}/>
                        {option.label}
                    </Box>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Nazionalità"
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                        fullWidth
                        error={formik.touched[attribute] && Boolean(formik.errors[attribute])}
                        helperText={formik.touched[attribute] && formik.errors[attribute]}/>
                )}
                sx={{mt:1}}/>

        </DialogContent>
        <DialogActions sx={{py: 2, px: 3}}>
            <Button color={"primary"}
                    variant={"text"}
                    onClick={onClose}>
                Cancella
            </Button>
            <LoadingButton onClick={() => formik.handleSubmit()}
                           loading={!!isLoading}
                           variant="contained">
                Salva
            </LoadingButton>
        </DialogActions>
    </Dialog>
}


CountryAttributeForm.propTypes = {
    attribute: PropTypes.string.isRequired,  // Name of the attribute (it will be passed in an object when submit is called)
    label: PropTypes.string.isRequired,  // Label of the attribute shown
    value: PropTypes.any,  // Initial value of the attribute
    defaultValue: PropTypes.object,  // Default value of the value
    validationSchema: PropTypes.object,  // Validation schema for the attribute
    onClose: PropTypes.func.isRequired,  // Function called when closing the form
    onSubmit: PropTypes.func.isRequired,  // Function called when submitting the form
    disableRequired: PropTypes.bool, //remove the asterisk on the TextField
    isLoading: PropTypes.bool,
    dialogTitle: PropTypes.string,
};

export default CountryAttributeForm;